<template lang="pug">
	.asset-video-generation-settings
		.form-line.model
			.form-group
				.field-title Vendor
				InputSelect(v-on:change="setVendor($event)" :default="vendorCodename" :value="vendorCodename" :values="vendors" :options="{editable: false, dropdownWidth: 174, displayedValueTransform: v => Metadata.AIVendorsByCodename[v]?.title || ''}" :disabled="!!readOnly" theme="dark-medium")
			.form-group
				.field-title Model
				InputSelect(v-on:change="setModel($event)" :default="modelCodename" :value="modelCodename" :values="models" :options="{editable: false, dropdownWidth: 174, dropdownHeight: 400, displayedValueTransform: v => Metadata.AIModelsByHierarchy[vendorCodename]?.[v]?.title || ''}" :disabled="!!readOnly" theme="dark-medium")
			.form-group
				.field-title
					span Size
					span.attached-images(v-if="attachmentsCount > 0" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'The first attached image is used as the start frame (image to video)'}") = start frame
				InputSelect(v-on:change="setSize($event)" :default="sizeCodename" :value="sizeCodename" :values="sizes" :options="{editable: false, dropdownWidth: 174, dropdownHeight: 400, displayedValueTransform: v => Metadata.AISizesByHierarchy[vendorCodename]?.[modelCodename]?.[v]?.title || ''}" :disabled="!!readOnly" theme="dark-medium")
			.form-group.duration
				.field-title Duration
				InputSelect(v-on:change="setDuration($event)" :default="duration" :value="duration" :values="durations" :options="{editable: false, dropdownWidth: 100, displayedValueTransform: v => v + 's'}" :disabled="!!readOnly || !prompt" theme="dark-medium")
			.form-group.count
				.field-title Count
				InputSelect(v-on:change="setCount($event)" :default="count" :value="count" :values="counts" :options="{editable: false, dropdownWidth: 50}" :disabled="!!readOnly || !prompt" theme="dark-medium")
		.form-line.separator.prompt
			.form-group
				.field-title
					.title
						span Video generation prompt
						span.attached-images(v-if="attachmentsCount === 1") +1 start frame
						span.attached-images(v-else-if="attachmentsCount > 1") +{{attachmentsCount}} start frames
					.history-button(v-if="readOnly !== true" @click="openPromptsHistory($event)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Prompts history'}")
						i.fa.fa-bars
				textarea(:disabled="!!readOnly" placeholder="The camera slowly moves around a glowing crystal" v-model="prompt" @input="updateSettings")
</template>

<script>

	import Screen 				from '../../mixins/screen'

	import InputSelect			from './../Editor/Controls/InputSelect'

	export default {
		name: "AssetVideoGenerationSettings",
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Creative Generations Loaded",
				"Selected Creative Generation Added",
				"Selected Creative Generation Changed: [status]",
				"Selected Creative Generation Removed"
			],
			events: {
			}
		},
		props: ['creative', 'asset', 'readOnly'],
		components: {
			InputSelect
		},
		data() {

			this.vendors = [];
			this.models = [];
			this.sizes = [];
			this.durations = [];
			this.counts = [];

			return {
				// По умолчанию генерация видео идёт моделью Leonardo Motion 2.0
				vendorCodename: "leonardo",
				modelCodename: "motion_2.0",
				sizeCodename: null,
				duration: 5,
				prompt: '',
				promptEnhancement: '',
				attachmentsCount: 0,
				count: 1
			}

		},
		methods: {
			collectData() {

				// Вендоры, у которых есть видео-модели
				let videoVendorCodenames = _.uniq(_.map(_.filter(Metadata.AIModels, model => model.type === 'video'), 'vendor_codename'));

				this.vendors = _.map(videoVendorCodenames, vendorCodename => {
					return {..._.pick(Metadata.AIVendorsByCodename[vendorCodename], ['title']), data: {itemValue: vendorCodename}}
				});

				// У вендора берём только видео-модели
				let models = _.pickBy(Metadata.AIModelsByHierarchy[this.vendorCodename], model => model.type === 'video');

				if (!models?.[this.modelCodename]) {

					let model = _.find(models, {active: 1}) || _.head(_.values(models));

					this.modelCodename = model?.codename || this.modelCodename;

				}

				this.models = _.map(models, model => {
					return {..._.pick(model, ['title']), description: `by ${model.developer}`, data: {itemValue: model.codename}}
				});

				this.sizes = _.map(Metadata.AISizesByHierarchy[this.vendorCodename]?.[this.modelCodename], size => {
					return {..._.pick(size, ['title', 'description']), data: {itemValue: size.codename}}
				});

				// Размер для видео задаёт соотношение сторон и разрешение - значение по умолчанию всегда обязательно
				if (!_.find(this.sizes, size => size.data.itemValue === this.sizeCodename) && this.sizes[0]) this.sizeCodename = this.sizes[0].data.itemValue;

				this.model = Metadata.AIModelsByHierarchy[this.vendorCodename][this.modelCodename];

				// Доступные длительности видео у выбранной модели (options.durations)
				let durations = this.model?.options?.durations || [5];

				this.durations = _.map(durations, duration => {
					return {title: `${duration}s`, data: {itemValue: duration}}
				});

				if (!durations.includes(this.duration)) this.duration = durations[0];

				let maxCount = this.model?.options?.maxCount || 1;

				this.counts = [];
				for (let i=0; i<maxCount; i++) this.counts.push({title: i+1, data: {itemValue: i+1}});

				if (this.count > maxCount) this.count = maxCount;

			},
			setVendor(vendorCodename) {

				this.vendorCodename = vendorCodename;

				// У каждого вендора свои модели, размеры и длительности - список настроек пересобирается
				this.collectData();

				this.updateSettings();

			},
			setModel(modelCodename) {

				this.modelCodename = modelCodename;

				// У каждой модели свои размеры и длительности - список настроек пересобирается
				this.collectData();

				this.updateSettings();

			},
			setSize(sizeCodename) {

				this.sizeCodename = sizeCodename;

				this.updateSettings();

			},
			setDuration(duration) {

				this.duration = duration;

				this.updateSettings();

			},
			setCount(count) {

				this.count = count;

				this.updateSettings();

			},
			setPrompt(prompt) {

				this.prompt = prompt;

				this.updateSettings();

			},
			updateSettings() {

				this.$emit("change", this.getSettings());

			},
			setSettings(settings) {

				if ("vendorCodename" in settings) this.vendorCodename = settings.vendorCodename;
				if ("modelCodename" in settings) this.modelCodename = settings.modelCodename;
				if ("sizeCodename" in settings) this.sizeCodename = settings.sizeCodename || null;
				if ("duration" in settings) this.duration = settings.duration;
				if ("count" in settings) this.count = settings.count;
				if ("prompt" in settings) this.prompt = settings.prompt;
				if ("promptEnhancement" in settings) this.promptEnhancement = settings.promptEnhancement;

				// Настройки могли быть установлены для другого вендора и модели - пересобираем списки и сообщаем об изменениях
				this.collectData();

				this.updateSettings();

			},
			getSettings() {

				return {
					vendorCodename: this.vendorCodename,
					modelCodename: this.modelCodename,
					sizeCodename: this.sizeCodename,
					duration: this.duration,
					count: this.count,
					prompt: this.prompt,
					promptEnhancement: this.promptEnhancement
				}

			},
			setAttachmentsCount(attachmentsCount) {

				this.attachmentsCount = attachmentsCount;

				this.update();

			},
			openPromptsHistory(e) {

				let assetPrompts = _.filter(Asset.Generations, generation => generation["creative_id"] === this.creative.id && generation["asset_codename"] === this.asset?.codename && _.trim(generation.prompt));
				assetPrompts = _.uniqBy(assetPrompts, "prompt");

				let creativePrompts = _.filter(Asset.Generations, generation => (generation["creative_id"] === this.creative.id) && _.trim(generation.prompt));
				creativePrompts = _.uniqBy(creativePrompts, "prompt");

				let userPrompts = _.filter([...Asset.UserGenerationPrompts, ..._.filter(Asset.Generations, generation => (generation["user_id"] === User.currentUser.id))], gen => _.trim(gen.prompt));

				userPrompts = _.uniqBy(userPrompts, "id");
				userPrompts = _.uniqBy(userPrompts, "prompt");

				let items = [
					{title: "Asset level prompts", width: 250, childs: _.map(assetPrompts, gen => {return {title: gen.prompt, data: {itemValue: gen.prompt}}})},
					{title: "Creative level prompts", width: 250, childs: _.map(creativePrompts, gen => {return {title: gen.prompt, data: {itemValue: gen.prompt}}})},
					{title: "Your previous prompts", width: 250, childs: _.map(userPrompts, gen => {return {title: gen.prompt, data: {itemValue: gen.prompt}}})},
					{title: "Prompt examples", width: 200, childs: [
						{title: "Cinematic camera move around a mobile game slot background", data: {itemValue: "Cinematic camera move around a mobile game slot background"}, wordWrap: true}
					]},
				];

				Broadcast.call("Show InputSelectDropdown", [e.currentTarget, items, {
					value: items[0].title,
					header: {title: 'Prompts history', description: 'Select previous prompts from these lists'},
					autoClose: true,
					callback: (data) => {

						this.setPrompt(data.itemValue);

					}
				}]);

			}
		}
	}
</script>

<style lang="sass">

	.asset-video-generation-settings
		display: flex
		flex-direction: column

		.attached-images
			color: var(--orange)
			margin-left: 10px

		.form-line
			display: flex
			flex-direction: row

		.form-group
			display: flex
			flex-direction: column
			margin: 0

			&:first-child
				margin-left: 0

		.field-title
			margin-bottom: 5px
			cursor: default
			color: var(--gray)

		.model
			margin-bottom: 10px

			.form-group
				margin-right: 10px

			.field-title
				margin-left: 1px

			.form-group.duration

				.input-select-control
					width: 100px

			.form-group.count

				.input-select-control
					width: 50px

		.prompt

			.form-group
				width: 100%

			textarea
				height: 85px
				resize: none
				background-color: #515b65
				border: 1px solid #23282c
				border-radius: 0.2rem
				color: white
				padding: 0.3rem
				font-size: 0.9rem
				margin-bottom: 0px
				outline: none

			textarea::placeholder
				color: rgba(255,255,255,0.1)

			.field-title
				display: flex
				flex-direction: row
				align-items: center
				justify-content: space-between
				margin-left: 2px

				.history-button
					cursor: pointer
					padding: 0px 5px
					transition: color 0.2s

					&:hover
						color: var(--primary)

</style>

